/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import custom component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHeaderForManufacturer } from './gridComponents/tableHead';
// import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  radioGroupLabelNameSelectBy,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  tabHighLigther,
  isReadOnly as isRead,
} from '../../../../SharedModules/utilities/utilities';
import {
  redirectURLLink,
  upperCaseFirstLetter,
  lowerCaseAllWordsExceptFirstLetters,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import {
  handleErrorMessages,
  getCmsDrugByCriteria,
  getAuditTypeDropDownList,
  getManufacturerList,
  setSearchCmsDrugTab,
  setPreviousDrugData,
  dispatchCmsDrugCriteriaList,
  setDetailScreenObj,
  setMfgSelected,
  dispatchCmsDrugCriteria,
  setCmsDrugDetailTab,
} from '../store/Actions';

const DrugFileSearch = ({ location }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState).readOnly;
  }
  /* dispatch function */
  const setSearchCmsDrug = (value) => dispatch(setSearchCmsDrugTab(value));
  const searchCmsDrugTabData = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.searchCmsDrugObj
  );

  const fetchManufacturerList = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.manufacturerList
  );

  const auditTypeOptions = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.auditTypeList
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.CMSDrugFileReducer?.errorMessagesInRedux
  );
  const mfgSelected = useSelector(
    (state) => state.sharedState?.CMSDrugFileReducer?.mfgSelected
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const previousData = useSelector(
    (state) => state?.sharedState?.CMSDrugFileReducer?.previousData
  );

  const cmsDrugDetailObj = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.cmsDrugDetailObj
  );
  // variable declaration
  const searchCompObj = searchCmsDrugTabData?.state?.searchTypeState;
  const errorMessagesOfSearchTypeComp =
    errorMessagesFromRedux?.searchScreenErrors?.length > 0
      ? _.filter(
          errorMessagesFromRedux?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const gridRef = React.useRef();

  const [manufacturerList, setManufacturerList] = useState([]);

  const [fullScreenView, setFullScreenView] = useState(false);
  const [labelerFullScreen, setLabelerFullScreen] = useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = useState(
    searchCompObj?.labelerSelectedRowRedux
      ? searchCompObj?.labelerSelectedRowRedux
      : ''
  );
  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] = useState(
    searchCompObj?.ndcLeftTableDataRedux
      ? searchCompObj?.ndcLeftTableDataRedux
      : []
  );
  const [ndcRightTableData, setNdcRightTableData] = useState(
    searchCompObj?.ndcRightTableDataRedux
      ? searchCompObj?.ndcRightTableDataRedux
      : []
  );
  const [ndcSearchVal, setNdcSearchVal] = useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );

  const [searchType, setSearchType] = useState(
    searchCompObj?.valueSelectedRedux
      ? searchCompObj?.valueSelectedRedux
      : userDefaults?.defNdcSelectModeCd
      ? userDefaults?.defNdcSelectModeCd === 'NDC'
        ? 'NDC'
        : upperCaseFirstLetter(
            lowerCaseAllWordsExceptFirstLetters(
              userDefaults?.defNdcSelectModeCd
            )
          )
      : 'NDC'
  );
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = useState(
    errorMessagesOfSearchTypeComp
  );
  const [selectManufacturer, setSelectManufacturer] = useState(
    mfgSelected ? mfgSelected : {}
  );
  const [state, setState] = useState(
    searchCmsDrugTabData?.state
      ? searchCmsDrugTabData.state
      : {
          selectBy: 'A',
          auditTypeCd: 'ALL',

          selectedAuditType: '-1',
          clearedIndex: false,
          unclearedIndex: true,
          allAuditTypes: true,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );

  const editReduxCmsDrugDetail = (value) =>
    dispatch(setCmsDrugDetailTab(value));

  // handing refresh functionality
  React.useEffect(() => {
    const searchObj = {
      valueSelectedRedux: searchType || 'NDC',
      ndcSearchTextRedux: ndcSearchVal || '',
      ndcNameSearchTextRedux: ndcNameSearchVal || '',
      ndcLeftTableDataRedux: ndcLeftTableData || [],
      ndcRightTableDataRedux: ndcRightTableData || [],
      labelerTableDataRedux: labelerTableData || [],
      ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
      ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
      labelerSelectedRowRedux: labelerSelectedRow || '',
      labelerFullScreenRedux: labelerFullScreen,
      ndcLeftFullScreenRedux: ndcLeftFullScreen,
      ndcRightFullScreenRedux: ndcRightFullScreen,
    };
    setState({ ...state, searchTypeState: searchObj });
    setSearchCmsDrug({
      fullScreenView: fullScreenView,
      state: { ...state, searchTypeState: searchObj },
    });
  }, [
    searchType,
    labelerSelectedRow,
    ndcLeftSelectedRows,
    ndcRightSelectedRows,
    labelerTableData,
    ndcLeftTableData,
    ndcRightTableData,
    ndcSearchVal,
    ndcNameSearchVal,
    labelerFullScreen,
    ndcLeftFullScreen,
    ndcRightFullScreen,
  ]);
  // handing full screen view
  React.useEffect(() => {
    if (labelerFullScreen || ndcLeftFullScreen || ndcRightFullScreen) {
      setFullScreenView(true);
      const searchObj = {
        valueSelectedRedux: searchType || 'NDC',
        ndcSearchTextRedux: ndcSearchVal || '',
        ndcNameSearchTextRedux: ndcNameSearchVal || '',
        ndcLeftTableDataRedux: ndcLeftTableData || [],
        ndcRightTableDataRedux: ndcRightTableData || [],
        labelerTableDataRedux: labelerTableData || [],
        ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
        ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
        labelerSelectedRowRedux: labelerSelectedRow || '',
        labelerFullScreenRedux: labelerFullScreen,
        ndcLeftFullScreenRedux: ndcLeftFullScreen,
        ndcRightFullScreenRedux: ndcRightFullScreen,
      };

      setSearchCmsDrug({
        fullScreenView: true,
        state: { ...state, searchTypeState: searchObj },
      });
    } else {
      setFullScreenView(false);
      setSearchCmsDrug({
        fullScreenView: false,
        state: state,
      });
    }
  }, [labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);
  // handling onPage load call service

  React.useEffect(() => {
    if (state.selectBy === 'M' && fetchManufacturerList?.length == 0) {
      dispatch(getManufacturerList({ mfgId: null, showAllInd: true }));
    }
    if (!auditTypeOptions?.length > 0) {
      dispatch(
        getAuditTypeDropDownList({ domainKey: 'AUDIT_TYPE_CD', codeValue: 'D' })
      );
    }
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    if (
      searchCmsDrugTabData &&
      Object.keys(searchCmsDrugTabData).length === 0
    ) {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    } else if (searchCmsDrugTabData?.fullScreenView) {
      setFullScreenView(searchCmsDrugTabData.fullScreenView);
    }
  }, []);

  // set Manufacturer list
  React.useEffect(() => {
    setManufacturerList(fetchManufacturerList);
  }, [fetchManufacturerList]);

  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/cmsDrugFileDiscrepancies', true);
    } else {
      tabHighLigther('/cmsDrugFileDiscrepancies', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // click on filter icon after call
  const handleClearFilter = () => {
    if (manufacturerList && manufacturerList.length > 0 && gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  // Calling API for Manufacturer List
  const getManufactureListData = () => {
    dispatch(
      getManufacturerList({
        showAllInd: true,
      })
    );
    handleClearFilter();
  };
  // handing On change event on filed level

  const handleOnChangeEvent = (value, name) => {
    if (name === 'selectBy' && value !== state.selectBy) {
      setState({
        ...state,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });

      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'NDC'
      );
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');

      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      setSearchCmsDrug({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      let errorMsgWithoutSearch = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];
      errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
        (item) => item?.field !== 'NoSelectedRow'
      );
      setErrorMsgFromSearchType([]);

      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(errorMsgWithoutSearch)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }

    if (name === 'allAuditTypes') {
      setState({ ...state, [name]: value, selectedAuditType: '-1' });
      setSearchCmsDrug({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value, selectedAuditType: '-1' },
      });
    } else if (name === 'unclearedIndex') {
      setState({
        ...state,
        [name]: value,
        clearedIndex: (state.clearedIndex = true),
      });
      setSearchCmsDrug({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          [name]: value,
          clearedIndex: (state.clearedIndex = true),
        },
      });
    } else if (name === 'clearedIndex') {
      setState({
        ...state,
        [name]: value,
        unclearedIndex: (state.unclearedIndex = true),
      });
      setSearchCmsDrug({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          [name]: value,
          unclearedIndex: (state.unclearedIndex = true),
        },
      });
    } else {
      setState({ ...state, [name]: value });
      setSearchCmsDrug({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value },
      });
    }
    if (name === 'selectBy' && value === 'M' && !fetchManufacturerList) {
      getManufactureListData();
    }
  };

  // set Error messages
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];

      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );

      alreadyPresentErrors = alreadyPresentErrors.concat(errors);

      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
  };
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setSearchCmsDrug({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };
  // redirect view detail page
  const handleViewButton = () => {
    redirectURLLink(
      '/cmsDrugFileDetail',
      'CMS Drug File Detail',
      history,
      dispatch,
      isReadOnly
    );
  };
  const handleViewDetailFunction = async (data) => {
    var detailScreenErr = [];

    var localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    localErr = localErr.filter((item) => item.field !== 'NoSelectedRow');
    const drugSeqArr = [];
    if (state.selectBy === 'N') {
      data.forEach((elem) => {
        drugSeqArr.push(elem.drugSeqNum);
      });
    }
    var obj = {
      asCode: state.selectBy,
    };

    if (state && state.clearedIndex) {
      obj = { ...obj, clearedIndex: 1 };
    }
    if (state && state.unclearedIndex) {
      obj = { ...obj, unClearedIndex: 0 };
    }
    if (!(state && state.allAuditTypes)) {
      obj = { ...obj, auditType: state.selectedAuditType };
    }

    var objForAPI =
      state.selectBy === 'M'
        ? {
            ...obj,
            mfgId: data.mfgId,
          }
        : state.selectBy === 'N'
        ? {
            ...obj,
            drugSeqNum: drugSeqArr,
          }
        : { ...obj };
    const resultData = await dispatch(getCmsDrugByCriteria(objForAPI));

    if (resultData && resultData?.searchDrugByCriteriaList?.length > 0) {
      localErr = localErr.filter((item) => item.field !== 'resultNotFound');
      dispatch(setPreviousDrugData(resultData?.searchDrugByCriteriaList));
      const objSave = cmsDrugDetailObj || {};
      editReduxCmsDrugDetail({
        ...objSave,
        disabledSaveCancelBtn: false,
      });

      if (objForAPI) {
        dispatch(dispatchCmsDrugCriteria(objForAPI));
      }

      handleViewButton();
      detailScreenErr = [];
      dispatch(
        setDetailScreenObj({
          clearedCheckBox: state.clearedIndex,
          unClearedCheckBox: state.unclearedIndex,
        })
      );
    } else {
      localErr = localErr.filter((item) => item.field !== 'resultNotFound');
      localErr = localErr.filter((item) => item.field !== 'searchByNameError');

      dispatch(dispatchCmsDrugCriteriaList(previousData));
      localErr.push({
        field: 'resultNotFound',
        errorType: 'resultNotFound',
        errorComponent: 'searchTypeComponent',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      detailScreenErr = errorMessagesFromRedux?.detailScreenErrors
        ? errorMessagesFromRedux?.detailScreenErrors
        : [];
    }
    var searchErrors = localErr?.filter(
      (item) => item.errorComponent === 'searchTypeComponent'
    );
    setErrorMsgFromSearchType(searchErrors);
    if (localErr && !localErr.length > 0) {
      tabHighLigther('/cmsDrugFileDiscrepancies', false);
    }
    if (localErr?.length > 0) {
      handleScrollToEvent();
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: detailScreenErr,
      })
    );
  };

  // handing by default row selection function
  const onGridReady = (params) => {
    if (manufacturerList && manufacturerList?.length > 0) {
      if (mfgSelected?.mfgId) {
        params.api.forEachNode(
          (node) =>
            node?.data?.mfgId == mfgSelected?.mfgId && node?.setSelected(true)
        );
      } else {
        params.api.forEachNode(
          (node) => node?.rowIndex == 0 && node?.setSelected(true)
        );
      }
    }
  };
  // handing select a manufacturer row
  const onSelectManufacturer = (e) => {
    setSelectManufacturer(e.data);
    dispatch(setMfgSelected(e.data));
  };

  return (
    <div
      className="tBillPanel custom-check tabs-container frr-cmd-drug-file"
      data-testid="cms-drug-file-search"
    >
      <CustomSeparator
        parent1="Research"
        parent2="CMS / Drug File Discrepancies"
      />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(
                      errorMessagesFromRedux.searchScreenErrors,
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
          <Spinner load={spinnerLoader} />
        </>
      )}
      {!fullScreenView && (
        <div className="row mb-2">
          <div className="col-7 col-sm-12 col-md-6 col-lg-6 pr-0 mt-3">
            <RadioGroupComponent
              data-testid="filter-plan-by-radio-btn-select-by-dfd"
              id="filter-plan-by-radio-btn-action"
              labelName={radioGroupLabelNameSelectBy}
              required={false}
              optionList={[
                { name: 'Manufacturer', value: 'M' },
                { name: 'NDC', value: 'N' },
                { name: 'Select All For Above Criteria', value: 'A' },
              ]}
              defaultValue={state && state.selectBy}
              filterAction={(e) => {
                if (e !== 'M') {
                  setSelectManufacturer({});
                  dispatch(setMfgSelected({}));
                }
                handleOnChangeEvent(e, 'selectBy');
              }}
              className=""
            />
          </div>
          <div className="col-3 col-sm-12 col-md-3 col-lg-6 pr-0 position-relative frr-all-audit-selectbox">
            <div className="frr-mt-37">
              <div className="d-flex flex-column">
                <div className="d-flex no-lbl">
                  <FormControlLabel
                    className="ml-0 frr-no-wrap"
                    data-testid="all_audit_dfd"
                    control={<Checkbox color="primary" className="mr-2" />}
                    label="All&nbsp;Audit&nbsp;Types"
                    value={state.allAuditTypes}
                    checked={state.allAuditTypes}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.checked, 'allAuditTypes')
                    }
                  />
                  <div className="with-select frr-width-200">
                    <TextField
                      data-testid="selec_audit_type_dfd"
                      id="selectedAuditType"
                      label="Audit Type"
                      name="selectedAuditType"
                      fullWidth
                      className="frr-display-hidden-label"
                      select
                      disabled={state.allAuditTypes}
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'selectedAuditType' }}
                      InputLabelProps={{ shrink: true }}
                      value={state && state.selectedAuditType}
                      onChange={(e) => {
                        handleOnChangeEvent(
                          e.target.value,
                          'selectedAuditType'
                        );
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {auditTypeOptions && auditTypeOptions.length > 0
                        ? auditTypeOptions.map((item) => {
                            return (
                              <MenuItem
                                key={item.codeValue}
                                value={item.codeValue}
                              >
                                {`${item.codeValue} | ${item.shortDescription}`}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
                <div>
                  <FormControlLabel
                    className="ml-0 frr-no-wrap"
                    data-testid="checked_dfd"
                    control={<Checkbox color="primary" className="mr-2" />}
                    label="Include Cleared Audits"
                    value={state.clearedIndex}
                    checked={state.clearedIndex}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.checked, 'clearedIndex')
                    }
                  />
                </div>
                <div>
                  <FormControlLabel
                    className="ml-0 frr-no-wrap"
                    data-testid="unchecked_dfd"
                    control={<Checkbox color="primary" className="mr-2" />}
                    label="Include Uncleared Audits"
                    value={state.unclearedIndex}
                    checked={state.unclearedIndex}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.checked, 'unclearedIndex')
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {(state && state.selectBy === 'A') ||
          (state && state.selectBy === 'M') ? (
            <>
              <div className="col-5 pr-0"></div>
              <div className="col-7 pr-0">
                <div className="mui-custom-form input-md frr-checkinvoice-search text-right frr-width-75per">
                  <Button
                    className="btn btn-success btn-save"
                    data-testid="process-button-dfd"
                    onClick={() => {
                      let localErr = errorMessagesFromRedux?.searchScreenErrors
                        ? errorMessagesFromRedux?.searchScreenErrors
                        : [];
                      if (state.selectBy === 'M') {
                        if (
                          selectManufacturer &&
                          Object.keys(selectManufacturer).length > 0
                        ) {
                          localErr = localErr.filter(
                            (item) => item.field !== 'NoSelectedRow'
                          );
                          handleViewDetailFunction(selectManufacturer);
                        } else {
                          localErr.push({
                            field: 'NoSelectedRow',
                            errorType: 'NoSelectedRow',
                            message: constantMessageData.NOT_SELECTED_ROW,
                          });
                        }
                      } else {
                        handleViewDetailFunction();
                      }
                      if (localErr?.length > 0) {
                        handleScrollToEvent();
                      }
                      dispatch(
                        handleErrorMessages({
                          searchScreenErrors: [...new Set(localErr)],
                          detailScreenErrors:
                            errorMessagesFromRedux?.detailScreenErrors
                              ? errorMessagesFromRedux?.detailScreenErrors
                              : [],
                        })
                      );
                    }}
                  >
                    <SVGComponent iconName="Icon-view" />
                    &nbsp;View Discrepancies
                  </Button>
                  <div className="mt-2"></div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      )}
      <div>
        {state && state.selectBy === 'M' && manufacturerList?.length > 0 ? (
          <TableGrid
            ref={gridRef}
            gridCall={onGridReady}
            data-testid="manufacturer-dfd-table"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={manufacturerList}
            columnDefs={TableHeaderForManufacturer}
            onSelect={(e) => {
              onSelectManufacturer(e);
            }}
            cellClickedListener={(e) => {
              handleViewDetailFunction(e.data);
              setSearchCmsDrug({
                state: state,
                fullScreenView: fullScreenView,
                selectRowIndex: e.rowIndex,
              });
            }}
            exportFile
            animateRows
            sideBar={false}
            helpMessage="* On Double Click of Results, system should navigate to Detail page"
            fileName="CMS Drug File-Manufacturer"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
          />
        ) : state && state.selectBy === 'N' ? (
          <div className="mt-3">
            <SearchTypeComponent
              id="CMS-Drug"
              data-testid="search-type-dfd"
              viewDetailButtonName="View Discrepancies"
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={handleViewDetailFunction}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default DrugFileSearch;
